exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-5dde1ace] {\n  width: 0.333333rem;\n  height: 0.333333rem;\n  line-height: 0.333333rem;\n  text-align: center;\n  border-radius: 0.052083rem;\n  background: #f3f6ff;\n  cursor: pointer;\n}\n.border-normal[data-v-5dde1ace]:hover {\n  border: 0.005208rem solid #1e49e2;\n}\n.item-number[data-v-5dde1ace] {\n  font-size: 0.15625rem;\n  font-weight: bold;\n}\n.item-name[data-v-5dde1ace] {\n  font-size: 0.083333rem;\n  font-weight: bold;\n  text-align: center;\n}\n.not-allowed[data-v-5dde1ace] {\n  cursor: not-allowed !important;\n}", ""]);

// exports
